<template>
	<v-card class="flex">
		<v-card-text class="pa-0" style="height: 100%;display: flex;flex-direction: column;">
			<div style="flex: 1 1 100%">
				<ActividadTable
					:actividad="actividad"
				/>
			</div>
			<div style="flex: 1">
				<ActividadButton
					block
					depressed
					:actividad="actividad"
					:mecanicoEstaAsignado="mecanicoEstaAsignado"
					@click="onClickCard()"
				/>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import ActividadButton from '../shared/ActividadButton.vue';
import ActividadTable from "../shared/ActividadTable.vue";
export default {
	components: { ActividadTable, ActividadButton },
	props: {
		actividad: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		mecanicoEstaAsignado() {
			return this.actividad.mecanicos?.some(
				(mecanico) => mecanico.idPersona == this.actividad.idPersona
			) || false;
		},
		computedBackground() {
			switch (this.actividad.tipo) {
				case 1:
					return "background-green";
				case 2:
					return "background-blue";
				case 3:
					return "background-pink";
				case 4:
					return "background-orange";
				default:
					return "background-grey";
			}
		},
		computedColsIcon() {
			return this.isMobile ? "12" : "2";
		},
		computedColsTable() {
			return this.isMobile ? "12" : "10";
		},
	},
	methods: {
		onClickCard() {
			this.$emit("click", this.actividad);
		},
	},
};
</script>
<style scoped>
.background-green {
	background-color: #a5d6a7;
}

.background-pink {
	background-color: #f48fb1;
}

.background-orange {
	background-color: #ffcc80;
}

.background-blue {
	background-color: #90caf9;
}

.background-grey {
	background-color: #e0e0e0;
}
</style>